import styled, { useTheme } from "styled-components/native";
import { useCameraPermissions } from "expo-camera";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBIcons } from "@utils/VDBIcons";
import Routes from "@navigations/Routes";
import { Alert, Linking, Platform } from "react-native";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { navigate } from "@navigations/utils/RootNavigation";
const BarcodeButton = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const globalData = useSelector((state: any) => state.globalData);
  const userInfo = useSelector((state: any) => state.userInfo);
  const showBarcodeScanner = globalData?.barcode_scanner;
  const iconName = showBarcodeScanner?.icon;
  if (
    !showBarcodeScanner?.enabled ||
    !showBarcodeScanner?.price_modes.includes(userInfo?.user?.price_mode) ||
    Platform.OS === "web"
  ) {
    return null;
  }

  const [permission, requestPermission] = useCameraPermissions();
  const requestCameraPermission = async () => {
    if (permission?.canAskAgain) {
      const result = await requestPermission();
      if (result.granted) {
        return;
      }
    }

    Alert.alert(
      t("barcodeScanner.permission.alert.title.text", {
        defaultValue: "Camera Permission Required",
      }),
      t("barcodeScanner.permission.alert.message.text", {
        defaultValue:
          "Camera access has been denied. Please enable it in your device settings to use the barcode scanner.",
      }),
      [
        {
          text: t("barcodeScanner.permission.alert.cancel.text", {
            defaultValue: "Cancel",
          }),
          style: "cancel",
        },
        {
          text: t("barcodeScanner.permission.alert.openSettings.text", {
            defaultValue: "Open Settings",
          }),
          onPress: () => Linking.openSettings(),
        },
      ]
    );
  };
  const handleBarcodePress = async () => {
    if (!permission?.granted) {
      if (permission?.canAskAgain) {
        const mResult = await requestPermission();
        if (!mResult.granted) {
          return;
        }
      } else {
        // Permission permanently denied, show settings alert
        requestCameraPermission();
        return;
      }
    }

    navigate(Routes.GlobalNavigator, {
      screen: Routes.BarcodeScannerScreen,
    });
  };

  return (
    <BarcodeButtonContainer
      onPress={handleBarcodePress}
      hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
    >
      <VDBIcon
        name={
          iconName?.type === "url"
            ? undefined
            : iconName?.data || VDBIcons.BARCODE_SCANNER
        }
        size={24}
        color={theme["core-04"]}
        variant={
          iconName?.type === "url"
            ? IconsVariant.CustomUrl
            : IconsVariant.VDBCustom
        }
        {...(iconName?.type === "url" ? { uri: iconName?.data } : {})}
      />
    </BarcodeButtonContainer>
  );
};

const BarcodeButtonContainer = styled.TouchableOpacity``;

export default BarcodeButton;
